module.exports = __webpack_public_path__ + "img/step2.6709e4ff.svg";